<!-- Inputs centrale Modal-->
<template>
    <b-modal
      v-if="cu != null"
      :visible="visible" 
      @hidden="hide" 
      @change="change"
      @show="loadInputs"
      @ok="saveConfiguration"
      ok-only
      scrollable
      ref="modal"
      id="modal-inputs-cu"
      no-close-on-backdrop
      :title="$t('inputs_cu_modal.title', {tipo: cu.cu_type, id: cu.cu_id})"
      :hide-footer="true"
      :ok-title="setting_changed?$t('advanced_cu_modal.modify_settings'):$t('close')"
    >

      <b-container fluid>
        <b-row>
          <b-col v-if="cu.cu_product_image" cols="4" class="my-auto text-center">
            <img  :src="pathDeviceImages  + cu.cu_product_image" style="height:60px; width:auto;" />
          </b-col>
          <b-col v-else cols="4" class="my-auto text-center">
              <img  v-if="cu.cu_type=='logicafm'" :src="'/img/logicafmsd/centrale.png'" style="height:60px; width:auto;" />
              <img  v-if="cu.cu_type=='logica'" :src="'/img/logica/centrale.png'" style="height:60px; width:auto;" />
              <img  v-if="cu.cu_type=='cablecom'" :src="'/img/cablecom/centrale.png'" style="height:60px; width:auto;" />
          </b-col>
                <b-col cols="8">
                    <b-row>
                        <b-col cols="6">
                            <b-row><b-col cols="12">{{$t("details_cu_modal.cu_type")}}</b-col></b-row>
                            <b-row><b-col cols="12"><strong>{{cu.cu_type}}</strong></b-col></b-row>
                        </b-col>
                        <b-col cols="6">
                            <b-row><b-col cols="12">{{$t("details_cu_modal.cu_id")}}</b-col></b-row>
                            <b-row><b-col cols="12"><strong>{{cu.cu_id}}</strong></b-col></b-row>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col cols="12">
                            <b-row><b-col cols="12">{{$t("details_cu_modal.cu_descrizione")}}</b-col></b-row>
                            <b-row>
                                <b-col cols="10"><strong>{{cu.cu_desc}}</strong></b-col>                          
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
          </b-row>

          <b-tabs v-model="tabIndex" class="PlanimetrieTabs typo-label mt-4" >
              
              <!-- Info 4 Input -->
              <b-tab v-for="(item, index) in this.generic_inputs" v-bind:key="index" :title="$t('inputs_cu_modal.input') + (index+1)" id="tab_inputs" lazy>
                <div class="typo-data">
                    <b-row>
                      <b-col cols="4" offset-sm="1">{{$t("inputs_cu_modal.state")}} : </b-col>
                      <b-col cols="7">{{item.hwState}}</b-col>
                    </b-row>  
                    <b-row>
                      <b-col cols="4" offset-sm="1">{{$t("inputs_cu_modal.logic_state")}} : </b-col>
                      <b-col cols="7">{{item.lgState}}</b-col>
                    </b-row>  
                    <b-row>
                      <b-col cols="4" offset-sm="1">countdown : </b-col>
                      <b-col cols="7">{{item.countdownEnabled}}</b-col>
                    </b-row> 
                </div>
              </b-tab>

               <!-- Info Lssa Input -->
              <b-tab :title="$t('inputs_cu_modal.lssa_input')" id="tab_inputs" lazy>
                <div class="typo-data">
                    <b-row>
                      <b-col cols="4" offset-sm="1">stato : </b-col>
                      <b-col cols="7">{{$t('inputs_cu_modal.'+this.lssa_input.hwState)}}</b-col>
                    </b-row>  
                    <b-row>
                      <b-col cols="4" offset-sm="1">stato logico : </b-col>
                      <b-col cols="7">{{this.lssa_input.lgState}}</b-col>
                    </b-row>  
                    <b-row>
                      <b-col cols="4" offset-sm="1">countdown : </b-col>
                      <b-col cols="7">{{this.lssa_input.countdownEnabled}}</b-col>
                    </b-row> 
                </div>
              </b-tab>
              
              <!-- Info Relay -->
              <b-tab :title="$t('inputs_cu_modal.relay')" lazy>
              <div class="typo-data">
                    <b-row>
                      <b-col cols="7" offset-sm="1">{{$t('inputs_cu_modal.relay_state')}} : </b-col>
                      <b-col cols="4">{{this.cu.cu_relay.relayState}}</b-col>
                    </b-row>  
                    <b-row>
                      <b-col cols="7" offset-sm="1">{{$t('inputs_cu_modal.automatic_mode')}} : </b-col>
                      <b-col cols="4">{{this.cu.cu_relay.automaticMode}}</b-col>
                    </b-row>  
                    <b-row>
                      <b-col cols="7" offset-sm="1">{{$t('inputs_cu_modal.fase_timer')}} : </b-col>
                      <b-col cols="4">{{this.cu.cu_relay.faseTimer}}</b-col>
                    </b-row> 
                    <b-row>
                      <b-col cols="7" offset-sm="1">{{$t('inputs_cu_modal.function')}} :</b-col>
                      <b-col cols="4">{{this.cu.cu_relay.function}}</b-col>
                    </b-row>  
                    <b-row>
                      <b-col cols="7" offset-sm="1">{{$t('inputs_cu_modal.trigger_lssa')}} :</b-col>
                      <b-col cols="4">{{this.cu.cu_relay.triggerAssenzaReteLssa}}</b-col>
                    </b-row>  
                    <b-row>
                      <b-col cols="7" offset-sm="1">{{$t('inputs_cu_modal.trigger_error_lamps')}} :</b-col>
                      <b-col cols="4">{{this.cu.cu_relay.triggerErrorLamps}}</b-col>
                    </b-row>  
                    <b-row>
                      <b-col cols="7" offset-sm="1">{{$t('inputs_cu_modal.trigger_rest_mode')}} :</b-col>
                      <b-col cols="4">{{this.cu.cu_relay.triggerRestModePerm}}</b-col>
                    </b-row>  
                </div>
              </b-tab>

          </b-tabs>
      </b-container>    

    </b-modal>
</template>

<script>
import Vue from 'vue'
import { mapState } from "vuex";

export default {
  name: "InputsCentralUnit",
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    cu: {
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    sendAction: null,
  },
  data() {
    return {
      cuSerial: "",
      cuType: "",
      cuDesc:"",
      tabIndex: 0,
      generic_inputs:[],
      lssa_input:{},
      footer_hide: false,
      plantUnits: this.$store.state.plantUnits,
      cu_flags_selected: [], 
      cu_flags_options: [],
      cu_flags_setted:[],
      maxPlantCode:92,
      selected_plant_code:null,
      pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES,   
    };
  },
  computed: { 
    setting_changed()
    {
      if((this.tabIndex==1 && this.cu_flags_setted!=null && this.cu_flags_selected!=null && this.cu_flags_setted!=this.cu_flags_selected) || (this.tabIndex==2 && this.cu.plant_code!=this.selected_plant_code)) return true
      return false
    }
  },
  methods: {  
    loadInputs(){
     //set default tab 
     this.tabIndex=0;
     this.generic_inputs=[],
     //set 4 inputs
     this.generic_inputs.push(this.cu.cu_inputs.inputs[0]);
     this.generic_inputs.push(this.cu.cu_inputs.inputs[1]);
     this.generic_inputs.push(this.cu.cu_inputs.inputs[2]);
     this.generic_inputs.push(this.cu.cu_inputs.inputs[3]);

     //set lssa input
     this.lssa_input=this.cu.cu_inputs.inputs[4];
  

    },
    hide() {
      this.$emit("hide");
    },
    change(visible) {
      this.$emit("change", visible);
    },
    saveConfiguration() {
      
      if(this.tabIndex==2)
      {
        var params = {};
        params.command = "setPlantCode";
        params.plantCode = this.selected_plant_code;
        console.log("Set plant code:", params);
        this.sendAction(params);
      }

      if(this.tabIndex==1)
      {
        var params = {};
        params.command = "setCuFlags";
        params.cuFlags = this.cu_flags_selected;
        console.log("Set Cu flags", params);
        this.sendAction(params);
      }

      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs.modal.hide();
      });
    },
    handleRemove(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
     }
  }
};
</script>

<style lang="scss">
  #tab_advanced .nav-tabs{
        font-weight: bold;
    }
  .typo-data{
    font-weight:400;
    font-family: Roboto;
    font-size: 13px;
  }
</style>